import React from 'react';
import { Card } from '../ui/Card';

export const SectionWrapper = ({ title, subtitle, step, children }) => {
  return (
    <Card className="mb-8">
      <div className="mb-6">
        {step && <h3 className="text-[10px] font-bold text-brand-muted uppercase tracking-widest mb-2">Section {step}</h3>}
        <h2 className="text-xl font-serif text-brand-text">{title}</h2>
        {subtitle && <p className="text-sm text-brand-muted mt-1">{subtitle}</p>}
      </div>
      {children}
    </Card>
  );
};